import styled from '@emotion/styled'

export const VendorMaintenanceContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: 'auto',
  width: '-webkit-fill-available',

  '.breadcrumbsRow': {

  },

  'div.headerRow': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '.sectionLeft': {
      display: 'flex',
      flexDirection: 'column',
    },

    'span.title': {
      fontSize: '1.5rem',
      fontWeight: 'bold',
    },
  },
  
  '.ReactTable.prItems': {
    borderRadius: '5px',

    '.rt-tbody': {
      '.rt-tr-group': {
        '.rt-tr': {
          '.rt-td': {
            // whiteSpace: 'normal',
            // wordWrap: 'break-word',
          },
        },
      },
    },

    '.-pagination ': {
      '.-previous': {
        button: {
          fontFamily: 'IBM Plex Sans Thai',
          fontSize: '1.25rem',
          fontWeight: 'bold',
        },
      },

      '.-center': {
        flex: 2,
        justifyContent: 'center',
  
        '.-pageInfo': {
          display: 'flex',
          alignItems: 'center',
  
          '.-pageJump': {
            width: '50px',
            margin: '0px 5px',

            input: {
              width: '100%',
              fontFamily: 'IBM Plex Sans Thai',
            },
          },
  
          '.-totalPages': {
            marginLeft: '5px',
            fontSize: '12px',
            fontFamily: 'IBM Plex Sans Thai',
          },
        },

        '.-pageSizeOptions': {
          select: {
            fontFamily: 'IBM Plex Sans Thai',
          },
        }
      },

      '.-next': {
        button: {
          fontFamily: 'IBM Plex Sans Thai',
          fontSize: '1.25rem',
          fontWeight: 'bold',
        },
      },
    }
  },

  '.ReactTable.budgets': {
    borderRadius: '5px',
  },

  '.ReactTable.poList, .ReactTable.downPaymentList, .ReactTable.contractList , .ReactTable.billFormList': {
    borderRadius: '5px',
    marginTop: '15px',
    
    '.rt-tbody': {
      '.rt-tr-group': {
        '.rt-tr': {
          '&:hover': {
            cursor: 'pointer',
            background: 'rgba(0,0,0,0.05)',
          }
        },
        '.rt-tr.-odd': {
          background: 'rgba(0,0,0,0.03)',
        },
      },
    },
  },

  '.ReactTable.poItems': {
    borderRadius: '5px',
    width: '100%',
    maxWidth: '100%',

    '.poItemDescription, .poItemName': {
      whiteSpace: 'normal',
    },
  },

  '@media only screen and (min-width: 600px)': {
    '.ReactTable.poItems': {
      borderRadius: '5px',
      width: '10%',
    },
  },

  '@media only screen and (min-width: 769px)': {
    '.ReactTable.poItems': {
      borderRadius: '5px',
      width: '10%',
    },
  },
})

export const VendorMaintenanceBody = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: 'auto',
  marginTop: '15px',

  'div.btnContainer': {
    display: 'flex',
    width: '100%',
    marginTop: '1rem',
    justifyContent: 'center',

    'div.left': {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-start',
    },

    'div.right': {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-end',
    },
  },

  '.MuiCardHeader-root': {
    padding: '5px 16px',
  },

  '.MuiCardHeader-action': {
    margin: '0px',
  },

  '&>div>div.ui.menu': {
    overflowX: 'scroll'
  },

  // Billing
  '&>form>div>div.ui.menu': {
    overflowX: 'scroll'
  },

  '@media only screen and (min-width: 600px)': {
    '&>div>div.ui.menu': {
      overflowX: 'unset'
    },

    // Billing
  '&>form>div>div.ui.menu': {
    overflowX: 'unset'
  },
  },

  '@media only screen and (min-width: 769px)': {
    '&>div>div.ui.menu': {
      overflowX: 'unset'
    },

    // Billing
  '&>form>div>div.ui.menu': {
    overflowX: 'unset'
  },
  },
})